import React, { useEffect } from "react";
import Modal from "../../modal/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const EditUserModal = ({ show, handleClose, user, onUpdate, isLoading }) => {
    const validationSchema = Yup.object({
        full_name: Yup.string().required("Full name is required"),
        national_id_number: Yup.string()
            .required("National Insurance Number is required")
            .matches(/^\d+$/, "National Insurance Number must contain only numbers"),
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        phone: Yup.string().required("Phone number is required"),
        user_role: Yup.string().required("Select at least one role"),
    });

    const formik = useFormik({
        initialValues: {
            full_name: "",
            national_id_number: "",
            email: "",
            phone: "",
            user_role: "",
        },
        validationSchema,
        onSubmit: (values) => {
            onUpdate(user.id, values);
        },
        enableReinitialize: true,
    });

    const {
        values,
        handleChange,
        handleSubmit,
        handleBlur,
        errors,
        setFieldValue,
        setValues,
    } = formik;

    useEffect(() => {
        if (user) {
            setValues({
                full_name: user.full_name || "",
                national_id_number: user.national_id_number || "",
                email: user.email || "",
                phone: user.phone || "",
                user_role: user.user_role || "admin",
            });
        }
    }, [user, setValues]);

    const roleOptions = [
        { value: "admin", label: "Admin" },
        { value: "reviewer", label: "Reviewer" },
        { value: "Viewer", label: "Viewer" },
    ];

    const handleNationalIdChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setFieldValue("national_id_number", value);
        }
    };

    return (
        <Modal show={show} handleClose={handleClose} colWidth={6}>
            <div className="d-flex justify-content-center mb-4">
                <h2>Edit User</h2>
            </div>
            <div className="empAdd">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-6 mb-3">
                            <div className="fieldWrap">
                                <label>Full Name</label>
                                <input
                                    name="full_name"
                                    type="text"
                                    placeholder="Full Name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.full_name}
                                    className={errors.full_name ? "error-input" : ""}
                                />
                                {errors.full_name && (
                                    <div className="error-message">{errors.full_name}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-6 mb-3">
                            <div className="fieldWrap">
                                <label>National Insurance Number</label>
                                <input
                                    name="national_id_number"
                                    type="text"
                                    placeholder="123456"
                                    onChange={handleNationalIdChange}
                                    onBlur={handleBlur}
                                    value={values.national_id_number}
                                    className={errors.national_id_number ? "error-input" : ""}
                                    maxLength={8}
                                />
                                {errors.national_id_number && (
                                    <div className="error-message">
                                        {errors.national_id_number}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-6 mb-3">
                            <div className="fieldWrap">
                                <label>Email Address</label>
                                <input
                                    name="email"
                                    type="text"
                                    placeholder="Email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    className={errors.email ? "error-input" : ""}
                                />
                                {errors.email && (
                                    <div className="error-message">{errors.email}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-6 mb-3">
                            <div className="fieldWrap">
                                <label>Phone No.</label>
                                <PhoneInput
                                    country={"bs"}
                                    value={values.phone}
                                    onChange={(phone) => setFieldValue("phone", phone)}
                                    onBlur={handleBlur}
                                    placeholder="(242) 555-0122"
                                    countryCodeEditable={false}
                                    masks={{ bs: "...-...." }}
                                    inputProps={{ name: "phone" }}
                                    className={errors.phone ? "error-input" : ""}
                                />
                                {errors.phone && (
                                    <div className="error-message">{errors.phone}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-6 mb-3">
                            <div className="fieldWrap">
                                <label>Role</label>
                                <select
                                    style={{ width: "100%", padding: "10px" }}
                                    name="user_role"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.user_role}
                                    className={errors.user_role ? "error-input" : ""}
                                >
                                    <option value="">Select Role</option>
                                    {roleOptions.map((role) => (
                                        <option key={role.value} value={role.value}>
                                            {role.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.user_role && (
                                    <div className="error-message">{errors.user_role}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-12 d-flex justify-content-start mt-4">
                            <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isLoading}
                            >
                                {isLoading ? "Updating..." : "Update User"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default EditUserModal;
